<template>
  <div id="Sign">
    <nav-bar backPath="/agreement" class="nav_fixed">
      <i slot="left-icon" class="icon-back public_icon"></i>
      <div slot="center">协议签订</div>
    </nav-bar>
    <div class="sign-wrapper">
      <div class="agreement_bg paddinglr" slot="scroll">
        <template v-if="isShow">
          <div class="s-agreement-title white_card">
            <h5>公寓管理服务协议</h5>
            <!-- <p>{{ sign.agreementNumber }}</p> -->
          </div>
          <div class="agreement-content bgcF paddinglr">
            <p>请认真阅读以下协议内容，签字代表已同意。</p>
            <span class="btn-left inlineblock" @click="toUrl(wordPath)">
              <i class="agreement_icon"></i>
              查看协议pdf
            </span>
          </div>
        </template>

        <!-- 本人签名 -->
        <div class="s-agreement-sign">
          <div style="position: relative">
            <p class="s-agreement-sign-title">
              <span class="sign-title">本人签名：</span>
              <span v-show="!isShow" @click="signConfirm(1)" class="sign-back">返回</span>
              <!-- <span
                                class="r" v-if="isShow" @click="upSignature(1)">显示横屏</span><span class="r" v-else
                                @click="upSignature(2)">还原</span> -->
            </p>
            <div
              class="signature-box"
              style="height: 150px"
              v-show="isShow"
              v-on:touchstart="siginSrc ? '' : upSignature(1)"
            >
              <img
                v-if="siginSrc"
                style="width: 100%; height: 150px"
                :src="siginSrc"
                alt=""
              />
              <p
                v-else
                style="
                  text-align: center;
                  padding-top: 65px;
                  font-size: 14px;
                  letter-spacing: 2px;
                  color: #999;
                "
              >
                请点击签订
              </p>
            </div>
            <div class="signature-box" id="signatureparent">
              <div id="signature"></div>
            </div>
            <p class="btns btns-old" v-if="isShow">
              <button
                type="button"
                class="btn btn-clear btn-block"
                id="clear"
                @click="upSignature(1)"
              >
                重新签名
              </button>
              <!-- <button type="button" class="btn btn-save btn-block" :disabled="isSaveBtnDisabled" id="save"
                                @click="signConfirm1">确认<span v-show="isSaveBtnDisabled">{{saveBtnLightCount +
                                    's'}}</span></button> -->
              <button
                type="button"
                class="btn btn-save btn-block"
                :disabled="siginSrc ? false : true"
                id="save"
                @click="signSubmit"
              >
                确认
              </button>
            </p>
            <p class="btns btns-copy" v-show="!isShow">
              <button
                type="button"
                class="btn btn-clear btn-block"
                id="clear"
                @click="onReset"
              >
                重新签名
              </button>
              <button
                type="button"
                class="btn btn-save btn-block"
                @click="signConfirm(2)"
              >
                确认
              </button>
            </p>
          </div>
          <div class="sweet-warn">
            <h6><i class="sbAnbassador_icon icon_heart"></i> 温馨提醒</h6>
            <p>
              为维护你的个人权益，请务必使用正楷签字，签字审核通过后可下载电子协议，请务必妥善保管。
            </p>
          </div>
        </div>
      </div>
    </div>
    <!-- 学员信息确认 -->
    <Modal
      :isShow="modal01"
      topsite="40%"
      rightsite="6%"
      leftsite="6%"
      margintop="-125px"
    >
      <div slot="modalContent" class="sign_modal" v-show="isShowIdcomfirmModal">
        <!-- 身份验证弹窗 2021.11.15 14:00新增 -->
        <div class="idcomfirm-modal">
          <div class="idcomfirm-inner" v-show="!isConfirmStep2">
            <h5 class="idcomfirm-title">请核对身份信息</h5>
            <div class="idcomfirm-content">
              <p class="idcomfirm-p">
                为确保学员的合法权益受到保护，请核对和完善您的身份信息！
              </p>
              <dl class="info-item">
                <dt class="form-field">真实姓名：</dt>
                <dd class="form-input name-input">
                  <input
                    id="student_name"
                    type="text"
                    v-model="StudentName"
                    placeholder="请输入真实姓名"
                    @input="inputName"
                    v-on:blur="checkEnd"
                    v-on:focus="checkStart"
                  />
                </dd>
                <i
                  class="icon_yanzheng"
                  v-if="StudentName && StudentName.length > 0 && !isInputErr1"
                ></i>
                <!-- 表单验证提示 -->
                <dd class="input-err" for="student_name" v-show="isInputErr1">
                  请输入2-10位中文字符
                </dd>
              </dl>
              <dl class="info-item">
                <dt class="form-field">身份证号：</dt>
                <dd class="form-input id-input">
                  <input
                    id="idcard"
                    type="text"
                    v-model="IdCardNumber"
                    placeholder="请输入身份证号"
                    @input="inputIdCard"
                  />
                </dd>
                <i
                  class="icon_yanzheng"
                  v-if="IdCardNumber && IdCardNumber.length > 0 && !isInputErr2"
                ></i>
                <!-- 表单验证提示 -->
                <dd class="input-err" for="idcard" v-show="isInputErr2">
                  请输入正确的身份证号码
                </dd>
              </dl>
              <p class="hint-text">
                *身份证号仅用于签订协议，请确保以上信息与身份证上保持一致，如有误需自行承担责任！
              </p>
            </div>
            <div class="idcomfirm-footer">
              <button class="btn" @click.stop="nextStep">确认提交</button>
            </div>
          </div>
          <div class="idcomfirm-inner" v-show="isConfirmStep2">
            <div class="idcomfirm-content text-center">
              <i class="icon-js"></i>
              <p>请务必准确核对姓名和身份证号码，出错自行承担后果！</p>
            </div>
            <div class="idcomfirm-footer idcomfirm-footer-two">
              <button class="btn linear" @click.stop="preStep">上一步</button>
              <button class="btn" @click.stop="submitCheck">确认</button>
            </div>
          </div>
        </div>
      </div>
    </Modal>

    <!-- 报名须知弹框 -->
    <!-- <Modal
      :isShow="modal02"
      @modalbd-close="modalToggle02"
      topsite="40%"
      rightsite="5%"
      leftsite="5%"
      margintop="-125px"
    >
      <div slot="modalContent" class="sign_modal">
        <h2>报名须知</h2>
        <p v-html="decodeURIComponent(this.noticeContents)"></p>
        <button class="block" @click="modalToggle02">关闭</button>
      </div>
    </Modal> -->
    <!-- 确认框 -->
    <confirm
      :isTwoOpe="true"
      message="确认提交签名吗？"
      :is-show="isShowConfirm"
      @no-click="closeConfirm"
      @yes-click="postSign"
    ></confirm>
    <!-- 提交签名确认弹框 -->
    <!-- <Modal :isShow="modal03" @modalbd-close="modalToggle03" topsite="40%" rightsite="10%" leftsite="10%" margintop="-25px">
            <div slot="modalContent" class="sign_modal">
              <h2>确认提交签名吗？</h2>
			  <div class="modal_btn2">
				  <button class="inlineblock" @click="closeModalToggle03">取消</button>
				  <button class="inlineblock" @click="postSign">确定</button>
			  </div>
            </div>
        </Modal> -->
    <Foot class="Foot"></Foot>
  </div>
</template>
<script>
import Foot from "../../components/Foot.vue";
import NavBar from "components/common/NavBar";
import Modal from "components/common/modal/Modal";
import Confirm from "components/common/confirm/Confirm";
import $ from "jquery";
import "../../common/plugins/jSignature/jquery-vendor.js";
import "../../common/plugins/jSignature/jSignature.min.js";
import { isNull } from "common/utils";
import { getPersonalData } from "network/user";
import store from "../../store/index";
import { siteName } from "../../common/const";
import {
  getAgreementDetail,
  postAgreement,
  getNoticeContents,
  CheckSignIDCard,
  GetAgreementRerordDetail,
} from "network/agreementRecord";
// import $ from "jquery";
export default {
  name: "Sign",
  components: {
    NavBar,
    Modal,
    Confirm,
    Foot,
  },
  // props: {
  //   allConfig: {
  //     type: Object,
  //     default: () => {},
  //   },
  // },
  data() {
    return {
      modal01: false, // 学员信息弹窗
      modal02: false,
      modal03: false,
      modal04: false,
      NoticeShow: true,
      signId: "",
      sign: {},
      base64: "",
      isShowConfirm: false,
      noticeContents: "",
      siteName: siteName,
      StudentName: "",
      IdCardNumber: null,
      isInputErr1: false,
      isInputErr2: false,
      isConfirmStep2: false,
      isShowIdcomfirmModal: true,
      isShow: true, //是否显示横屏
      siginSrc: "",
    };
  },
  computed: {
    name() {
      return JSON.parse(localStorage.getItem("store")).userInfo.name || "";
    },
    idCard() {
      return JSON.parse(localStorage.getItem("store")).userInfo.idCard || "";
    },
    isCheckIdCard() {
      return JSON.parse(localStorage.getItem("store")).userInfo.isCheckIdCard || "";
    },
  },
  mounted() {
    console.log(this.name);
    this.$nextTick(() => {
      this.StudentName = this.name === "未设置" ? "" : this.name;
      this.IdCardNumber = this.idCard;
    });
    // document.body.style.backgroundColor = "#f6f6f6";
    // console.log($("#signature"))

    // if (!this.signature) {
    //   //判断是否已经初始化
    //   this.signature = $("#signature").jSignature({
    //     color: "#000",
    //     lineWidth: "3",
    //     width: "100%",
    //     height: 180,
    //     cssclass: "signature1",
    //     signatureLine: false,
    //   });
    // }
    //删除插件所带多余的样式div
    // $(".signature1>div").remove();
    if (this.$route.params.base64) {
      var dataurl = this.$route.params.base64;
      $("#signature").jSignature("importData", dataurl);
    }
    // $(".signature1>canvas").event.stopPropagation()
    // console.log($(".signature1>canvas"))
    // var canvas = document.querySelector('canvas');
    // console.log(canvas)
    // canvas.addEventListener("touchstart",  function(event) {event.preventDefault();brushMove();},false)
    // canvas.addEventListener("touchmove",   function(event) {event.preventDefault();brushMove()},false)
    // canvas.addEventListener("touchend",    function(event) {event.preventDefault();brushMove()},false)
    // canvas.addEventListener("touchcancel", function(event) {event.preventDefault();brushMove()},false)
  },
  created() {
    console.log(this.$route.query, "url传参");
    // this.wordPath = this.$route.query.wordPath;
    // 获取参数中的id
    this.signId = this.$route.query.id;
    this.modal01 = this.isCheckIdCard ? false : true;
    // this.getPage();
    this.getagreementInfo(this.signId);
  },
  methods: {
    // 获取协议详情
    async getagreementInfo(sign) {
      var res = await GetAgreementRerordDetail(sign);
      console.log(res, "获取协议详情");
      if (res && res.code == 1) {
        this.wordPath = res.result;
      } else {
        this.$confirm.show(res.message);
      }
    },
    //获取数据
    async getPage() {
      this.$loading.show("加载中…");
      let result = "";
      result = await getAgreementDetail(this.signId);
      console.log(result.result);
      if (result.code === 1) {
        this.sign = result.result;
        //报名须知为空则不显示入口
        // if (isNull(this.sign.NoticeContent)) {
        //   this.NoticeShow = false;
        // }
        // console.log(result);
        this.$loading.hide();
      } else {
        this.$loading.hide();
        this.$confirm.show(result.message);
      }
      //获取报名须知
      let result1 = "";
    },
    matchReg: function (str) {
      var decode = decodeURIComponent(str); //解码
      str = decode.replace("{", "");
      str = str.replace("}", "");
      str = str.replace("{#", "");
      str = str.replace("Img", "");
      str = str.replace("+", "");
      str = str.replace("#", "");
      str = str.replace("Signature", "待签字");
      str = str.replace("SigningTime", "待确认");
      str = str.replace("}", "");
      str = str.replace("{#", "");
      str = str.replace("#待签字", "待签字");
      return str;
    },

    // 确认画布
    signConfirm: function (type) {
      console.log(type);
      // type : 1为横屏返回，摧毁画布，展示竖屏
      // type : 2为横屏确认，为空提示先签名，后摧毁画布，保留签名，展示竖屏图片
      if (type == 1) {
        $(".s-agreement-sign").css({ "margin-top": "0" });
        $(".sign-title").css({
          transform: "inherit",
          position: "inherit",
          right: "-30px",
          top: "30px",
        });
        $(".s-agreement-content").show();
        $(".s-agreement-title").show();
        this.isShow = true;
        this.signature = $("#signature").jSignature("destroy");
      } else {
        var that = this;
        that.signImg = "";
        if ($("#signature").jSignature("getData", "native").length != 0) {
          $(".s-agreement-sign").css({ "margin-top": "0" });
          $(".sign-title").css({
            transform: "inherit",
            position: "inherit",
            right: "-30px",
            top: "30px",
          });
          // $(".btns-copy").css({ 'transform': 'inherit', 'position': 'inherit', 'left': '-49vw', 'top': '34vh', 'width': '100%' })
          //获取已经签名的数据，格式为base64:
          var datapair = $("#signature").jSignature("getData", "image");
          var i = new Image();
          i.src = "data:" + datapair[0] + "," + datapair[1];
          i.image = datapair[1];
          let src = "data:" + datapair.join(",");
          // 将base64图片旋转90度以后上传
          this.rotateBase64(src).then((img) => {
            // 旋转90°的正确签字图片
            that.siginSrc = img;
            that.signImg = img.replace("data:image/png;base64,", "");
            that.isShow = true;
            $(".s-agreement-content").show();
            $(".s-agreement-title").show();
            that.signature = $("#signature").jSignature("destroy");
          });
        } else {
          this.$toast.show("未绘制签名");
        }
      }
    },

    //将base64图片旋转90度以后上传
    rotateBase64(data) {
      return new Promise((resolve) => {
        const imgView = new Image();
        imgView.src = data;
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        const cutCoor = { sx: 0, sy: 0, ex: 0, ey: 0 }; // 裁剪坐标
        imgView.onload = () => {
          const imgW = imgView.width;
          const imgH = imgView.height;
          const size = imgH;
          canvas.width = size * 2;
          canvas.height = size * 2;
          cutCoor.sx = size;
          cutCoor.sy = size - imgW;
          cutCoor.ex = size + imgH;
          cutCoor.ey = size + imgW;
          context.translate(size, size);
          context.rotate((Math.PI / 2) * 3);
          context.drawImage(imgView, 0, 0);
          const imgData = context.getImageData(
            cutCoor.sx,
            cutCoor.sy,
            cutCoor.ex,
            cutCoor.ey
          );
          canvas.width = imgH;
          canvas.height = imgW;
          context.putImageData(imgData, 0, 0);
          resolve(canvas.toDataURL("image/png"));
        };
      });
    },
    //报名协议弹窗
    modalToggle01: function () {
      this.modal01 = !this.modal01;
    },
    toUrl(item) {
      console.log(item, "数据");
      var u = navigator.userAgent;
      console.log(u);
      if (u.indexOf("Android") > -1) {
        this.$router.push({
          path: "/AgreementRecord/detailPDF",
          query: {
            id: item.id,
            Path: item.pdfPath,
            title: `${
              item.areaLocationName.includes("校区")
                ? item.areaLocationName
                : `${item.areaLocationName}校区`
            }-${item.floorNumber}楼-${item.number}室`,
            back: "/AgreementRecord",
          },
        });
      } else {
        // this.$router.push({
        //   path: "/agreement/detailPDF",
        //   query: {
        //     id: item.id,
        //     Path: item.path,
        //     title: item.productName,
        //   },
        // });
        window.open(item.pdfPath);
      }
    },
    // 报名须知弹窗
    modalToggle02: function () {
      this.modal02 = !this.modal02;
    },
    // 重置签名
    onReset: function () {
      $("#signature").jSignature("reset");
    },
    async submitCheck() {
      var obj = {
        agreementRecordId: this.signId,
        studentName: this.StudentName,
        idCard: this.IdCardNumber,
      };
      const res = await CheckSignIDCard(obj);
      console.log(res);
      if (res && res.code == 1) {
        this.$Dialog
          .alert({
            title: "",
            message: res.message,
          })
          .then(() => {
            // on close
            this.modal01 = false;
          });
        // 校验成功请求用户信息接口
        let userInfo = "";
        const userRes = await getPersonalData();
        // alert('用户信息返回数据：'+JSON.stringify(userRes))
        if (userRes && userRes.code === 1) {
          userInfo = userRes.result;
          localStorage.setItem("wxOpenId", userInfo.weiXinOpenId); //存储wxOpenId
          userInfo.myInterals = 0; //临时模拟总积分数据，接口须新增返给前端
          store.commit("saveUserInfoStorage", userInfo);
          // 将新store数据覆盖localStorage中旧store数据(旧store为刷新页面前App.vue中存储的)
          window.localStorage.setItem("store", JSON.stringify(store.state));
        }
      } else {
        this.$Dialog
          .alert({
            title: "",
            message: res.message,
          })
          .then(() => {
            // on close
            this.preStep();
          });
        // this.$toast.show(res.code, 2000);
      }
    },
    // 放大画布/展示横屏
    upSignature: function (type) {
      console.log("134324");
      if (type == 1) {
        this.signImg = "";
        this.siginSrc = "";
        // 90°旋转外盒子宽度调整
        $("#signatureparent").css({ width: "75%", "margin-left": "15%" });
        $(".s-agreement-sign").css({ "margin-top": "-100px" });
        $(".sign-title").css({
          transform: "rotate(90deg)",
          position: "absolute",
          right: "-30px",
          top: "30px",
          marginRight: "10px",
        });
        $(".sign-back").css({
          transform: "rotate(90deg)",
          position: "absolute",
          right: "-7px",
          bottom: "15px",
          marginRight: "6px",
        });
        $(".btns-copy").css({
          transform: "rotate(90deg)",
          position: "absolute",
          left: "-47%",
          top: "46%",
          width: "100%",
        });
        this.$nextTick(() => {
          this.isShow = false;
        });
        $(".s-agreement-content").hide();
        $(".s-agreement-title").hide();
        this.signature = $("#signature").jSignature({
          color: "#000",
          lineWidth: "5",
          width: "100%",
          height: "550px",
          cssclass: "zx11",
          signatureLine: false,
        });
      }
    },
    closeConfirm: function () {
      this.$toast.show("取消上传签名", 1000);
      this.isShowConfirm = false;
    },

    // 1、提交按钮，显示确认框
    signSubmit() {
      console.log(123);
      var that = this;
      if (that.signImg) {
        that.isShowConfirm = true; //询问确认框显示
      } else {
        this.$toast("未绘制签名");
      }
    },
    preStep: function () {
      console.log(123);
      this.isConfirmStep2 = false;
    },
    // 全屏签名组件
    // clickAll() {
    //   this.modal04 = true;
    // },
    // 校验身份证信息
    // 提交核对信息
    nextStep: function () {
      if (
        !this.StudentName ||
        this.StudentName.length == 0 ||
        this.StudentName.indexOf("同学") > -1 ||
        this.StudentName.length > 10 ||
        this.StudentName.length < 2
      ) {
        this.$toast.show("请输入真实姓名！", 2000);
        return false;
      }
      if (this.isInputErr1) {
        this.$toast.show("请输入正确格式的姓名！", 2000);
        return false;
      }
      if (!this.IdCardNumber || this.IdCardNumber.length == 0) {
        this.$toast.show("请输入身份证号码！", 2000);
        return false;
      }
      if (this.isInputErr2) {
        this.$toast.show("请输入正确格式的身份证号码！", 2000);
        return false;
      }
      // this.isShowIdcomfirmModal = false;
      this.isConfirmStep2 = true;
    },
    // 身份证格式校验
    inputIdCard: function () {
      var cardreg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (
        this.IdCardNumber &&
        this.IdCardNumber.length > 0 &&
        !cardreg.test(this.IdCardNumber)
      ) {
        this.isInputErr2 = true;
      } else {
        this.isInputErr2 = false;
      }
    },
    // 姓名格式校验
    inputName: function () {
      var testExpress = /[^\u4E00-\u9FA5-\·]/g;
      this.StudentName = this.StudentName ? this.StudentName : "";
      var result = testExpress.test(this.StudentName);
      console.log(result);

      if (
        result ||
        this.StudentName.indexOf("同学") > -1 ||
        this.StudentName.length > 10 ||
        this.StudentName.length < 2
      ) {
        this.isInputErr1 = true;
      } else {
        this.isInputErr1 = false;
      }
    },
    // 姓名格式禁止输入
    checkChinese: function () {
      if (this.StudentName && this.StudentName.length > 0) {
        this.StudentName = this.StudentName.replace(/[^\u4E00-\u9FA5-\·]/g, ""); // 只能输入中文
        this.StudentName = this.StudentName.replace("同学", ""); //禁止输入同学二字
      }
    },
    checkEnd: function () {
      clearInterval(this.checkInterval);
    },
    checkStart: function () {
      this.checkInterval = setInterval(this.checkChinese, 100);
    },
    //提交签名
    async postSign() {
      this.$loading.show("提交中…");

      var params = {
        id: this.signId,
        imgUrl: this.signImg,
      };
      // console.log(typeof(this.base64))
      console.log(params);

      // console.log(params)
      let result = "";
      result = await postAgreement(params);
      console.log(result);
      if (result.code === 1) {
        this.$loading.hide();
        // this.sign=result.Result
        // this.$toast.show('提交成功',1500)
        this.$confirm.show("协议签订成功，请及时完成在线缴费");
        setTimeout(() => {
          // 跳协议列表
          this.$router.push({ path: "/myOrder" });
        }, 200);
        // console.log(result)
      } else {
        this.$loading.hide();
        this.$confirm.show(result.message);
        this.isShowConfirm = false;
        setTimeout(() => {
          // 跳协议列表
          this.$router.push({ path: "/agreementRecord" });
        }, 200);
      }
    },
  },
};
</script>

<style scoped>
#Sign {
  position: relative;
  height: 92vh;
}
.sign-wrapper {
  overflow: hidden;
  padding-top: 88px;
  padding-bottom: 90px;
}
.agreement_bg {
  background: url("../../assets/images/banner_agreement1.jpg") no-repeat;
  background-size: 100% auto;
  padding-top: 38%;
}
.s-agreement-title {
  text-align: center;
  padding: 0 28px;
  border-radius: 12px;
}
.s-agreement-title h5 {
  font-size: 28px;
  font-weight: bold;
  line-height: 42px;
  padding: 28px 0;
}
.s-agreement-title p {
  font-size: 28px;
  color: #ff745e;
  letter-spacing: 3px;
  line-height: 90px;
  border-top: 1px dashed #ccc;
}
.bgcF {
  background-color: #fff;
  padding: 0 30px;
}
.agreement-content {
  border-radius: 12px;
  padding: 30px;

  font-size: 28px;
  padding-top: 28px;
  padding-bottom: 24px;
  margin-bottom: 30px;
}
.agreement-content p {
  line-height: 44px;
  margin-bottom: 16px;
}
.agreement-content button {
  background: none;
  /* color: #68afff; */
  color: #34c7fa;
  line-height: 50px;
}
.borderbt0 {
  border-bottom: none;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
}
.sign_modal {
  padding: 38px 28px;
}
.sign_modal h2 {
  line-height: 46px;
  text-align: center;
  font-size: 28px;
  font-weight: 600;
  margin-bottom: 16px;
}
.sign_modal p {
  line-height: 46px;
  text-align: left;
  font-size: 28px;
  max-height: 440px;
  overflow: hidden;
  overflow-y: auto;
}
.sign_modal button {
  width: 260px;
  height: 70px;
  line-height: 70px;
  margin: 4px auto;
  /* border: 1px solid #ff745e; */
  /* color: #ff745e; */
  border-radius: 70px;
  background: none;
  margin-top: 40px;
}
/* 签名 */
.sign_box {
  min-height: 494px;
  padding-bottom: 0;
}
.signature_title {
  line-height: 90px;
}
.signature1 {
  background-color: rgb(239, 241, 245);
  width: 100%;
  margin-top: 20px;
}

.sign_box button.block {
  border-radius: 60px;
  color: #fff;
  line-height: 80px;
}
.sign_box .reset {
  /* background: #68afff; */
  background-color: #34c7fa;
  width: 100%;
  margin: 30px auto;
  margin-top: 0;
}
.sign_box .signature_ok {
  /* background: #ff745e; */
  background: #fd5252;
  /* width: 80%; */
  width: 100%;
  margin: 0 auto;
}
/* 提示 */
.i-heart {
  width: 44px;
  height: 44px;
  vertical-align: middle;
  background: #eee;
  margin-right: 10px;
  display: inline-block;
  background: url("../../assets/images/heart.png") no-repeat;
  background-size: 100% auto;
  margin-top: -3px;
}
.sweet-warn {
  background-color: #f6f9ff;
  border-radius: 20px;
  margin-top: 40px;
  padding: 28px;
}
.sweet-warn h6 {
  font-size: 28px;
  font-weight: 600;
  line-height: 46px;
}
.sweet-warn p {
  font-size: 24px;
  line-height: 46px;
}
.fenkaibox {
  margin: 0 !important;
  margin-top: -30px !important;
  padding-top: 0;
  padding-bottom: 40px;
  border-top: none;
}
/* 提交确认弹框 */
.modal_btn2 {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-top: 1px solid #eee;
}
.modal_btn2 button {
  width: 50%;
  border: none;
  border-radius: 0;
  margin-top: 0;
  line-height: 86px;
  height: 86px;
}
.modal_btn2 button:first-child {
  border-right: 1px solid #eee;
  color: #444;
}
.white_card {
  background: #fff;
  margin-top: 60px;
}
/* 协议签订页-身份信息核对弹窗 2021.11.15 14:00新增*/
.idcomfirm-modal,
.black-shade {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 112;
}

.black-shade {
  background-color: rgba(0, 0, 0, 0.6);
}

.idcomfirm-inner {
  position: fixed;
  left: 6%;
  right: 6%;
  top: 10%;
  /* bottom: 6%; */
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 113;
  border-radius: 0.6rem;
  background-color: #fff;
  /* border: 16px; */
}

.idcomfirm-title {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  height: 3rem;
  line-height: 3rem;
  background-color: #fff;
  border-top-left-radius: 0.16rem;
  border-top-right-radius: 0.16rem;
  padding-top: 0.32rem;
}

.idcomfirm-content {
  background-color: #fff;
  /* max-height:6rem;*/
  overflow-x: hidden;
  overflow-y: auto;
  padding: 0.8rem 1rem;
  font-size: 0.373333rem;
  line-height: 0.48rem;
  margin-top: -2px;
}

.idcomfirm-content .info-item {
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  padding: 0.5rem 1rem;
  margin-bottom: 1.6rem;
  position: relative;
}

.idcomfirm-content .info-item .form-field {
  display: inline-block;
  font-size: 1rem;
  height: 1.5rem;
  line-height: 1.5rem;
}

.idcomfirm-p {
  background-color: #edfbbb;
  border: 1px dashed #f00;
  letter-spacing: 1px;
  border-radius: 4px;
  padding: 0.6rem 0.8rem;
  line-height: 0.56rem;
  margin-bottom: 0.48rem;
}

.idcomfirm-content .hint-text {
  color: #fc4444;
  margin-top: 0.64rem;
  font-size: 0.9rem;
  transform: scale(0.9);
  -webkit-transform: scale(0.9);
  -ms-transform: scale(0.9);
  -o-transform: scale(0.9);
  letter-spacing: 1px;
  line-height: 1.2rem;
}

.idcomfirm-content .form-field {
  font-weight: bold;
  width: auto;
}

/* .idcomfirm-content .name-input{padding-left:1.4rem;}
*/
.idcomfirm-content .input-err {
  /* transform:scale(0.9);-webkit-transform:scale(0.9);-ms-transform:scale(0.9);-o-transform:scale(0.9);*/

  position: absolute;
  bottom: -1.2rem;
  color: #fd5252;
}

.icon_yanzheng {
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  background: url("../../assets/images/icon_yanzheng.png") no-repeat;
  background-size: contain;
  opacity: 0.9;
  position: absolute;
  right: 1rem;
  top: 50%;
  transform: translateY(-50%);
}

.idcomfirm-footer {
  background-color: #fff;
  text-align: center;
  border-bottom-left-radius: 0.16rem;
  border-bottom-right-radius: 0.16rem;
  padding: 0.32rem 0;
}

.idcomfirm-footer .btn {
  width: 8rem;
  text-align: center;
  line-height: 0.8rem;
  background-color: #4188f2;
  border-radius: 0.8rem;
  font-size: 1.1rem;
  color: #fff;
  margin-bottom: 0.32rem;
  outline: none;
}

.text-center {
  text-align: center;
}

.text-center p {
  font-weight: bold;
  letter-spacing: 1px;
  line-height: 1.56rem;
  margin-top: 0.2rem;
}

.icon-js {
  display: inline-block;
  width: 3.6rem;
  height: 3.6rem;
  background: url("../../assets/images/icon_jingshi.png") no-repeat;
  background-size: contain;
  margin: 0.48rem 0 1.16rem 0;
}
.idcomfirm-footer-two {
  display: flex;
  padding: 0 2rem 2rem;
}
.idcomfirm-footer-two .btn {
  width: 3.2rem;
  flex: 1;
}

.idcomfirm-footer-two .linear {
  background-color: #fff;
  border-radius: 16px;
  color: #4188f2;
  border: 1px solid #4188f2;
  margin-right: 0.32rem;
}
.form-input {
  padding-left: 5rem;
  height: 1.2rem;
  line-height: 1.2rem;
  width: 65%;
}

.form-input input {
  font-size: 1rem;
  line-height: 1.96rem;
  width: 100%;
  height: 1.96rem;
  border: none;
}

.form-input input {
  text-align: left;
  letter-spacing: 1px;
}
.name-input,
.id-input {
  padding-left: 2.2rem;
  display: inline-block;
}

.name-input input:disabled,
.id-input input:disabled {
  background-color: #eee;
  opacity: 0.7;
  border-radius: 4px;
  padding: 0 8px;
}
.name-input,
.id-input {
  padding-left: 0.5rem;
}

.signature-box {
  background-color: #eff1f5;
  border: 2px;
}
/* 签名 */
.s-agreement-title,
.s-agreement-content,
.s-agreement-sign {
  background-color: #fff;
  /* border: 1px solid #f2f2f2; */
  /* border-radius: 0.16rem; */
  /*margin-left:0.373333rem;margin-right:0.373333rem;*/
  /* margin-bottom: 0.24rem; */
  /* border-radius: 16px; */
}

.s-agreement-title {
  text-align: center;
  padding: 0 0.4rem;
}

.s-agreement-title h5 {
  font-size: 1.4rem;
  font-weight: bold;
  line-height: 2.56rem;
  padding: 0.32rem 0;
}

.s-agreement-title p {
  font-size: 0.373333rem;
  color: #ff745e;
  letter-spacing: 3px;
  line-height: 0.48rem;
  padding: 0.24rem 0;
  border-top: 1px dashed #ccc;
}

.s-agreement-content,
.s-agreement-sign {
  padding: 0.4rem;
  border-radius: 16px;
}

.s-agreement-content .read-hint {
  font-size: 0.373333rem;
  margin-bottom: 0.4rem;
  text-indent: 2em;
}

.s-agreement-content .agreement-link {
  margin-bottom: 0.24rem;
}

.s-agreement-content .agreement-link a {
  font-size: 0.373333rem;
  color: #68afff !important;
  line-height: 0.56rem;
  display: block;
  cursor: pointer;
  text-indent: 2em;
}

.s-agreement-content-inner {
  height: 8.8rem;
  overflow-x: hidden;
  overflow-y: auto;
  word-break: break-all;
  text-align: justify;
}

.s-agreement-sign-title {
  font-size: 0.9rem;
  font-weight: bold;
  line-height: 1.64rem;
}

.s-agreement-sign .btns {
  overflow: hidden;
}

.s-agreement-sign .btns .btn {
  border-radius: 1.8rem;
  line-height: 2.64rem;
  color: #fff;
  margin-top: 1rem !important;
}

.s-agreement-sign .btns .btn:active,
.s-agreement-sign .btns .btn:hover,
.s-agreement-sign .btns .btn:focus {
  outline: none;
}

.s-agreement-sign .btns .btn-clear {
  background-color: #4188f2;
  margin-top: 0.32rem;
  width: 45%;
  float: left;
}

.s-agreement-sign .btns .btn-save {
  background-color: #ea3d3d;
  width: 45%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.32rem;
  float: left;
  margin-left: 10%;
}

.s-agreement-sign .btns .btn-save:disabled {
  background-color: #ccc;
}

.agreement_icon {
  width: 54px;
  height: 44px;
  display: inline-block;
  vertical-align: middle;
  margin-right: 10px;
  background: url("../../assets/images/pdfimg.png") no-repeat center;
}
</style>
